import { render, staticRenderFns } from "./ReorderModal.vue?vue&type=template&id=2897d5b0&"
import script from "./ReorderModal.vue?vue&type=script&lang=js&"
export * from "./ReorderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports